export const productCombinationProgressLevelSteps = [
  {title: 'Setup'},
  {title: 'Display'},
  {title: 'Products'},
  {title: 'Review'},
]

export const routeTypeOptions = [
  {id: 1, displayText: '1'},
  {id: 10, displayText: '10'},
  {id: 30, displayText: '30'},
]

export const comboProductTableColumns = [
  {
    name_of_db_column: 'productName',
    label_of_column: 'Product Name',
    order_of_column: 1,
    minSize: 300,
    type: 'string',
  },
  {
    name_of_db_column: 'productId',
    label_of_column: 'Product ID',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 3,
  },
  {
    name_of_db_column: 'size',
    label_of_column: 'Size',
    order_of_column: 4,
  },
  {
    name_of_db_column: 'displayCategory',
    label_of_column: 'Display Category',
    order_of_column: 5,
  },
  {
    name_of_db_column: 'displayBrand',
    label_of_column: 'Display Brand',
    order_of_column: 6,
  },
]

export const comboProductTableColumnsWithQuantity = [
  ...comboProductTableColumns,
  {
    name_of_db_column: 'quantity',
    label_of_column: 'QTY',
    order_of_column: 7,
  },
]

export const comboProductsTableHeader = [
  {columnKey: 'productId', header: 'Combo Id', columnFilterPlaceholder: 'Combo Id'},
  {columnKey: 'productName', header: 'Combo Name', columnFilterPlaceholder: 'Combo Name'},
  {columnKey: 'comboStatus', header: 'Status', columnFilterPlaceholder: 'Status'},
  {columnKey: 'status', header: 'Availability', columnFilterPlaceholder: 'Availability'},
]
